import { ProductType } from '../../types';

interface ProductDeprecationInfo {
  lastOrderDate: string; // ISO: 'YYYY-MM-DD'
  label: string; // Display: 'April 16, 2026'
}

// --- DEPRECATION CONFIG (delete this entire file when no longer needed) ---
export const PRODUCT_DEPRECATION_DATES: Partial<
  Record<ProductType, ProductDeprecationInfo>
> = {
  BROKER_PRICE_OPINION: {
    lastOrderDate: '2026-04-16',
    label: 'April 16, 2026',
  },
  AGILE_EVALUATION: { lastOrderDate: '2026-04-22', label: 'April 22, 2026' },
  INSPECTION: { lastOrderDate: '2026-04-22', label: 'April 22, 2026' },
};

export const getDeprecationInfo = (
  productType: ProductType,
): ProductDeprecationInfo | null =>
  PRODUCT_DEPRECATION_DATES[productType] ?? null;
